// extracted by mini-css-extract-plugin
export default {"classes":"inactivityModal_classes__CPRoe","btnDiv":"inactivityModal_btnDiv__4Y6uN","bgRed":"inactivityModal_bgRed__y431F"};